export const FULL_TEXT_STYLES = {
  'h-superbig': {
    lg: {
      fontSize: '72px',
      lineHeight: '90px',
    },
    md: {
      fontSize: '56px',
      lineHeight: '70px',
    },
    base: {
      fontSize: '56px',
      lineHeight: '70px',
      fontWeight: '900',
    },
  },
  'h-big': {
    lg: {
      fontSize: '56px',
      lineHeight: '70px',
    },
    md: {
      fontSize: '42px',
      lineHeight: '52px',
    },
    base: {
      fontSize: '42px',
      lineHeight: '52px',
      fontWeight: '900',
    },
  },
  h1: {
    lg: {
      fontSize: '42px',
      lineHeight: '52px',
    },
    md: {
      fontSize: '36px',
      lineHeight: '48px',
    },
    base: {
      fontSize: '32px',
      lineHeight: '40px',
      fontWeight: '900',
    },
  },
  h2: {
    lg: {
      fontSize: '32px',
      lineHeight: '40px',
    },
    base: {
      fontSize: '28px',
      lineHeight: '36px',
      fontWeight: '900',
    },
  },
  h3: {
    lg: {
      fontSize: '28px',
      lineHeight: '36px',
    },
    base: {
      fontSize: '24px',
      lineHeight: '36px',
      fontWeight: '900',
    },
  },
  h4: {
    base: {
      fontSize: '20px',
      lineHeight: '32px',
      fontWeight: '900',
    },
  },
  h5: {
    base: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '900',
    },
  },
  h6: {
    base: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '900',
    },
  },
  'emphasized-text': {
    base: {
      fontSize: '28px',
      lineHeight: '36px',
      fontWeight: '900',
    },
  },
  'emphasized-additional-text': {
    base: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 'bold',
    },
  },
  'intro-text': {
    base: {
      fontSize: '20px',
      lineHeight: '32px',
    },
  },
  'text-line-spacing-big': {
    base: {
      fontSize: '18px',
      lineHeight: '28px',
    },
  },
  text: {
    base: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  'strong-text': {
    base: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 'bold',
    },
  },
  'mid-size-text': {
    base: {
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.16px',
    },
  },
  'strong-mid-size-text': {
    base: {
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.16px',
      fontWeight: 'bold',
    },
  },
  'small-text': {
    base: {
      fontSize: '12px',
      lineHeight: '20px',
      letterSpacing: '0.32px',
    },
  },
  'strong-small-text': {
    base: {
      fontSize: '12px',
      lineHeight: '20px',
      letterSpacing: '0.32px',
      fontWeight: 'bold',
    },
  },
  'btn-small': {
    base: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      fontWeight: '900',
    },
  },
  'btn-normal': {
    base: {
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: '900',
    },
  },
  'btn-large': {
    base: {
      fontSize: '1.25rem',
      lineHeight: '1.375rem',
      fontWeight: '900',
    },
  },
  'link-small': {
    base: {
      fontSize: '14px',
      lineHeight: '16px',
      letterSpacing: '0.16px',
    },
  },
  'link-normal': {
    base: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  'label-checkbox': {
    base: {
      fontSize: '14px',
      lineHeight: '16px',
      letterSpacing: '0.16px',
    },
  },
  'label-textarea': {
    base: {
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.16px',
      textTransform: 'uppercase',
    },
    focus: {
      fontSize: '12px',
      lineHeight: '13px',
      letterSpacing: '0.32px',
      textTransform: 'uppercase',
    },
  },
  'label-input': {
    base: {
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.16px',
      textTransform: 'uppercase',
    },
    focus: {
      fontSize: '12px',
      letterSpacing: '0.32px',
      lineHeight: '13px',
      textTransform: 'uppercase',
    },
  },
  'state-message': {
    base: {
      fontSize: '12px',
      lineHeight: '13px',
      letterSpacing: '0.32px',
    },
  },
};
